// Schemas Yup reutilizáveis — centralizados conforme LICOES §1.6
import * as Yup from 'yup';

const valorTexto = value => (value === null || value === undefined ? '' : String(value));
const somenteDigitos = value => valorTexto(value).replace(/\D/g, '');
// DW-0963: exportados para reuso em Utils/Helpers (validarCNPJ/validarCpfCnpj) — fonte única, sem drift.
export const somenteAlfanumerico = value => valorTexto(value).toUpperCase().replace(/[^A-Z0-9]/g, '');

export const cnpjValido = value => {
  const cnpj = somenteAlfanumerico(value);
  if (cnpj.length !== 14) return false;
  if (!/^[A-Z0-9]{12}\d{2}$/.test(cnpj)) return false;
  if (/^([A-Z0-9])\1{13}$/.test(cnpj)) return false;

  const calcularDigito = (base, pesos) => {
    const soma = base.split('').reduce((total, char, index) => (
      total + (char.charCodeAt(0) - 48) * pesos[index]
    ), 0);

    const resto = soma % 11;
    return resto < 2 ? '0' : String(11 - resto);
  };

  const base = cnpj.substring(0, 12);
  const primeiroDigito = calcularDigito(base, [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]);
  const segundoDigito = calcularDigito(`${base}${primeiroDigito}`, [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]);
  return cnpj.endsWith(`${primeiroDigito}${segundoDigito}`);
};

export const cnpjSchema = Yup.string()
  .required('CNPJ obrigatório')
  .test('cnpj-tamanho', 'CNPJ deve conter 14 caracteres', value => (
    somenteAlfanumerico(value).length === 14
  ))
  .test('cnpj-formato', 'CNPJ deve ter 12 caracteres alfanuméricos e 2 dígitos verificadores', value => (
    /^[A-Z0-9]{12}\d{2}$/.test(somenteAlfanumerico(value))
  ))
  .test('cnpj-valido', 'CNPJ inválido', value => (
    cnpjValido(value)
  ));

export const cpfSchema = Yup.string()
  .required('CPF obrigatório')
  .test('cpf-digitos', 'CPF deve conter 11 dígitos', value => (
    somenteDigitos(value).length === 11
  ));

export const cepSchema = Yup.string()
  .required('CEP obrigatório')
  .test('cep-digitos', 'CEP deve conter 8 dígitos', value => (
    somenteDigitos(value).length === 8
  ));

export const competenciaSchema = Yup.string()
  .required('Competência obrigatória')
  .matches(/^\d{4}-(0[1-9]|1[0-2])$/, 'Competência deve estar no formato mês/ano');

export const valorPercentualIpcaSchema = Yup.number()
  .transform((value, originalValue) => {
    if (originalValue === '') return undefined;
    if (typeof originalValue === 'string') {
      const normalizado = originalValue.replace(',', '.');
      return normalizado === '' ? undefined : Number(normalizado);
    }
    return value;
  })
  .typeError('Informe o IPCA em porcentagem')
  .required('IPCA obrigatório')
  .min(0, 'Negativo não permitido')
  .max(50, 'Valor implausivelmente alto');

// W-0587 — Relatório de Cidades por Região
export const relatorioCidadesSchema = Yup.object().shape({
  codigoRegiao: Yup.number()
    .required('Selecione uma região antes de gerar o relatório')
    .positive()
    .integer(),
  ordem: Yup.mixed()
    .oneOf(['codigo', 'descricao', 'estado-descricao'])
    .default('codigo'),
});
